import React from 'react';
import { investmentPerformanceData } from '../utils/mockData';
import ChartCard from '../components/dashboard/ChartCard';
const Investments: React.FC = () => {
  return <div className="space-y-6" data-id="element-1386">
      <div data-id="element-1387">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-1388">
          Investment Platform Oversight
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-1389">
          Manage investment partners, track performance, and monitor user
          engagement.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-1390">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1391">
          <div className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1392">
            Total Partners
          </div>
          <div className="mt-2 text-3xl font-semibold text-gray-900 dark:text-white" data-id="element-1393">
            12
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1394">
          <div className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1395">
            Active Offers
          </div>
          <div className="mt-2 text-3xl font-semibold text-gray-900 dark:text-white" data-id="element-1396">
            24
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1397">
          <div className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1398">
            Clicks Today
          </div>
          <div className="mt-2 text-3xl font-semibold text-gray-900 dark:text-white" data-id="element-1399">
            342
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1400">
          <div className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1401">
            Conversions Today
          </div>
          <div className="mt-2 text-3xl font-semibold text-gray-900 dark:text-white" data-id="element-1402">
            28
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6" data-id="element-1403">
        <ChartCard title="Investment Performance" subtitle="Clicks and conversions by investment type" data={investmentPerformanceData} type="bar" dataKeys={['clicks', 'conversions']} colors={['#3B82F6', '#10B981']} data-id="element-1404" />
      </div>
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden" data-id="element-1405">
        <div className="p-6 border-b border-gray-200 dark:border-gray-700" data-id="element-1406">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-1407">
            Investment Partners
          </h3>
        </div>
        <div className="overflow-x-auto" data-id="element-1408">
          <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1409">
            <thead className="bg-gray-50 dark:bg-gray-700" data-id="element-1410">
              <tr data-id="element-1411">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1412">
                  Partner
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1413">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1414">
                  Investment Types
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1415">
                  Conversion Rate
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1416">
                  Revenue
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1417">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1418">
              <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1419">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1420">
                  <div className="flex items-center" data-id="element-1421">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-1422">
                      V
                    </div>
                    <div className="ml-4" data-id="element-1423">
                      <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1424">
                        Vanguard
                      </div>
                      <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-1425">
                        ETFs, Mutual Funds
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1426">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-1427">
                    Active
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1428">
                  ETFs, Mutual Funds, Retirement
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1429">
                  24.8%
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1430">
                  $12,450
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1431">
                  <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1432">
                    View
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1433">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1434">
                  <div className="flex items-center" data-id="element-1435">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-green-100 flex items-center justify-center text-green-600" data-id="element-1436">
                      F
                    </div>
                    <div className="ml-4" data-id="element-1437">
                      <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1438">
                        Fidelity
                      </div>
                      <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-1439">
                        Stocks, Retirement
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1440">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-1441">
                    Active
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1442">
                  Stocks, ETFs, Retirement, Robo-Advisory
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1443">
                  22.3%
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1444">
                  $10,820
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1445">
                  <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1446">
                    View
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1447">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1448">
                  <div className="flex items-center" data-id="element-1449">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-600" data-id="element-1450">
                      R
                    </div>
                    <div className="ml-4" data-id="element-1451">
                      <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1452">
                        Robinhood
                      </div>
                      <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-1453">
                        Stocks, Crypto
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1454">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-1455">
                    Active
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1456">
                  Stocks, ETFs, Crypto
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1457">
                  18.5%
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1458">
                  $8,640
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1459">
                  <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1460">
                    View
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1461">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1462">
                  <div className="flex items-center" data-id="element-1463">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600" data-id="element-1464">
                      W
                    </div>
                    <div className="ml-4" data-id="element-1465">
                      <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1466">
                        Wealthfront
                      </div>
                      <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-1467">
                        Robo-Advisory
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1468">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200" data-id="element-1469">
                    Under Review
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1470">
                  Robo-Advisory, ETFs
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1471">
                  15.2%
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1472">
                  $5,230
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1473">
                  <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1474">
                    View
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};
export default Investments;